/*
|--------------------------------------------------------------------------
| State
|--------------------------------------------------------------------------
*/

const state = {
    component: null,
    showNavigation: true,
    theme: 'light',
};

/*
|--------------------------------------------------------------------------
| Actions
|--------------------------------------------------------------------------
*/

const actions = {
    showComponent({ commit }, data) {
        commit('showComponent', {
            name: data.name,
            props: data.props || undefined,
        });
    },

    hideComponent({ commit }) {
        commit('hideComponent');
    },

    showNavigation({ commit }) {
        commit('setNavigationVisible', { visible: true });
    },

    hideNavigation({ commit }) {
        commit('setNavigationVisible', { visible: false });
    },

    setTheme({ commit }, theme) {
        commit('setTheme', { theme });
    },
};

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

const mutations = {
    showComponent(state, data) {
        state.component = null;
        state.component = data;
    },

    hideComponent(state) {
        state.component = null;
    },

    setNavigationVisible(state, { visible }) {
        state.showNavigation = visible;
    },

    setTheme(state, { theme }) {
        if (!window._.includes(['light', 'dark'], theme)) {
            throw new Error(`Invalid theme given: ${theme}`);
        }

        state.theme = theme;
    },
};

/*
|--------------------------------------------------------------------------
| Export
|--------------------------------------------------------------------------
*/

export const header = {
    namespaced: true,
    actions,
    mutations,
    state,
};
